/* eslint-disable */
import { THEME_CHANGE_PALETTE_TYPE_DARK } from '../Theme.types';

/**
 * Change the type of the current palette to `dark` mode
 * @returns {ActionCreator<FromPayload<null, {}, THEME_CHANGE_PALETTE_TYPE_DARK>>} The created `Action`
 */
const themeChangePaletteTypeDark = () => ({ fromPayload }) => {
  return fromPayload(null, {}, THEME_CHANGE_PALETTE_TYPE_DARK);
};

export default themeChangePaletteTypeDark;
